import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MyUtil from '../../functions/MyUtil';
import FormMarketingLead from './FormMarketingLead';
import ListMarketingLead from './ListMarketingLead';

export default function MarketingLead(props) {
  const { match } = props;
  return (
    <Switch>
      {MyUtil.hasPermission(match.url, 'view') && (
        <Route exact path={`${match.url}`}>
          <ListMarketingLead />
        </Route>
      )}
      {MyUtil.hasPermission(match.url, 'add') && (
        <Route path={`${match.url}/add-marketing-lead`}>
          <FormMarketingLead />
        </Route>
      )}
      {MyUtil.hasPermission(match.url, 'update') && (
        <Route path={`${match.url}/edit-marketing-lead/:id`}>
          <FormMarketingLead />
        </Route>
      )}
    </Switch>
  );
}
